import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { MonitorService } from '../../../../common/services/Monitor.service';
import { TicketService } from '../../../../common/services/Ticket.service';
import { UserService } from '../../../../common/services/User.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { GroupService } from '../../../../common/services/Group.service';

declare var $: any;
declare var Chartist: any;

@Component({
  templateUrl: 'analytic.template.html',
  styleUrls: ['analytic.css'],
  providers: [MonitorService, TicketService, UserService, GroupService],
})
export class AnalyticComponent implements OnInit {
  no_image = 'assets/images/contact.png';
  public top: any = [];
  public allTopType: any = [{ id: '', text: '' }];
  public allSource: any = [{ id: '', text: '' }];
  public allStatus: any = [];
  public listStatus: any = [];
  public allAgent: any = [{ id: '', text: '' }];
  public typeTop = 'call_answer';
  public model: any = {};
  public data: any;
  public options: any = {};
  public user: any = {};
  public optionCompare: any = {};

  public modelFilter: any = {};
  public listAgent: any = [];
  public allGroup: any = [];
  public totalItem = 0;
  public totalPage = 0;
  public currentPage_agent = 1;
  public page_size = 10;
  public is_compare = false;

  constructor(
    private monitorService: MonitorService,
    private ticketService: TicketService,
    private userService: UserService,
    private toastr: ToastrService,
    private groupService: GroupService
  ) {
    this.allTopType = [
      {
        id: '',
        text: '',
      },
      {
        id: 'call_answer',
        text: 'Trả lời cuộc gọi',
      },
      {
        id: 'call_miss',
        text: 'Bị nhỡ cuộc gọi',
      },
      {
        id: 'call_reject',
        text: 'Từ chối cuộc gọi',
      },
      {
        id: 'ticket_status_solved',
        text: 'Ticket đã hoàn thành',
      },
      {
        id: 'ticket_status_doing',
        text: 'Ticket đang xử lý',
      },
      {
        id: 'ticket_status_close',
        text: 'Ticket đã đóng',
      },
      {
        id: 'call_inbound',
        text: 'Tiếp nhận cuộc gọi đến',
      },
      {
        id: 'call_outbound',
        text: 'Gọi ra cho khách',
      },
      {
        id: 'time_call',
        text: 'Thời gian đàm thoại',
      },
    ];

    this.allSource = [
      { id: '', text: '' },
      {
        id: 'hand',
        text: 'Tự tạo',
      },
      {
        id: 'call',
        text: 'Điện thoại',
      },
      {
        id: 'facebook',
        text: 'Facebook',
      },
      {
        id: 'email',
        text: 'Email',
      },
      {
        id: 'web',
        text: 'Chat Web',
      },
      {
        id: 'sms',
        text: 'SMS',
      },
    ];

    this.model = {
      start: moment().format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD'),
    };
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {
    this.getStatus();
    this.model['type'] = 'call_answer';
    this.loadTop(this.model);
    this.loadAnalytic({ user_id: this.user._id });
  }

  changeTypeTop($event) {
    if (this.typeTop != $event.value) {
      this.typeTop = $event.value;
      this.model['type'] = $event.value;
      this.loadTop(this.model);
    }
  }

  changeSource($event) {
    this.model['source'] = $event.value;
    // var query = _.assign({}, this.model);
    // query['start'] = moment(query['start']).unix();
    // query['end'] = moment(query['end']).unix();
    this.loadAnalytic(this.model);
  }

  submitFilter() {
    this.is_compare = false;
    // var query = _.assign({}, this.model);
    // query['start'] = moment(query['start']).unix();
    // query['end'] = moment(query['end']).unix();
    this.model['start'] = moment(this.model['start']).format('YYYY-MM-DD');
    this.model['end'] = moment(this.model['end']).format('YYYY-MM-DD');
    this.loadAnalytic(this.model);
    this.model['type'] = this.typeTop;
    this.loadTop(this.model);
  }

  changeStatus($event) {
    this.model['status'] = $event.value;
    // var query = _.assign({}, this.model);
    // query['start'] = moment(query['start']).unix();
    // query['end'] = moment(query['end']).unix();
    this.loadAnalytic(this.model);
  }

  loadAnalytic(request = {}) {
    this.monitorService.analytic(request).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.data = res.data;
        this.renderChart(this.data);
      }
    });
  }

  changedFilterGroup($event) {
    this.modelFilter['group_id'] = $event.value;
  }

  getGroups() {
    this.groupService.allGroup({ target: 'user' }).subscribe(res => {
      const groupList = [];
      res.data.forEach((c: any) => {
        groupList.push({
          text: c.name,
          id: c.id.toString(),
        });
      });
      this.allGroup = groupList;
    });
  }

  getStaffs(request: any = {}, sort: any = {}) {
    this.listAgent = [];
    request.offset = this.page_size * (this.currentPage_agent <= 0 ? 0 : this.currentPage_agent - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.userService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.listAgent = res.data.list;
        this.totalItem = res.data.total;
        const pageString = (this.totalItem / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
      } else {
        this.listAgent = [];
      }
    });
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage_agent) {
        this.currentPage_agent = page;
        this.getStaffs();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage_agent) {
          this.currentPage_agent = page;
          this.getStaffs();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  filterAgent() {
    const options = [];
    if (this.modelFilter.filter_agent_phone) {
      options.push({
        key: 'phone',
        condition: '=',
        value: this.modelFilter.filter_agent_phone,
      });
    }
    if (this.modelFilter.group_id) {
      options.push({
        key: 'group_id',
        condition: '=',
        value: this.modelFilter.group_id,
      });
    }
    this.getStaffs({ filters: JSON.stringify(options) });
  }

  renderChart(data) {
    this.options = {
      title: {
        text: 'Ticket',
      },

      subtitle: {
        text: '',
      },

      xAxis: {
        categories: [],
      },
      yAxis: {
        title: {
          text: 'Số ticket',
        },
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
      },

      plotOptions: {
        // line: {
        //     dataLabels: {
        //         enabled: true
        //     },
        //     enableMouseTracking: false
        // }
        area: {
          stacking: 'normal',
          lineColor: '#666666',
          lineWidth: 1,
          marker: {
            lineWidth: 1,
            lineColor: '#666666',
          },
        },
      },

      series: [],

      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 1500,
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
              },
            },
          },
        ],
      },
      chart: { height: 400, width: 800, type: 'area' },
    };
    let key = 'ticket_total_';

    if (this.model.source) {
      key = 'ticket_' + this.model.source + '_';
      const _source = _.find(this.allSource, { id: this.model.source });
      if (_source) {
        this.options.subtitle.text = _source.text;
      }
    }
    const points = [];

    if (this.model.status) {
      this.model.status.forEach(e => {
        const _status = _.find(this.listStatus, { key: e });
        if (_status) {
          _status['key_chart'] = key + _status.key;
          points.push(_status);
        }
      });
    } else {
      this.listStatus.forEach(e => {
        e['key_chart'] = key + e.key;
        points.push(e);
      });
    }

    const series = [];
    const label = [];
    data.forEach(d => {
      label.push(d._id.date);
    });

    if (points.length > 0) {
      points.forEach(e => {
        const tmp = {
          name: e.name,
        };
        const key_chart = e['key_chart'];
        tmp['data'] = [];
        data.forEach(d => {
          const value = d[key_chart] ? d[key_chart] : 0;
          tmp['data'].push(value);
        });
        series.push(tmp);
      });
    }

    this.options.series = series;
    this.options.xAxis.categories = label;
  }

  compareTo(friend) {
    this.is_compare = true;
    const query = _.assign({}, this.model);
    const queryFriend = _.assign({}, this.model);

    query['start'] = moment(query['start']).unix();
    query['end'] = moment(query['end']).unix();
    query['user_id'] = this.user._id;

    queryFriend['start'] = moment(queryFriend['start']).unix();
    queryFriend['end'] = moment(queryFriend['end']).unix();
    queryFriend['user_id'] = friend._id;

    this.monitorService.analytic(query).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.monitorService.analytic(queryFriend).subscribe(resFriend => {
          if (resFriend.status == 200 && !resFriend.error) {
            this.renderCompare(this.user.name, res.data, friend.name, resFriend.data);
          }
        });
      }
    });
  }

  renderCompare(user1, data1, user2, data2) {
    let categories = [];
    if (this.model.status) {
      const tmp_cats = [];
      this.model.status.forEach(e => {
        const status = _.find(this.listStatus, { key: e });
        tmp_cats.push(status.name);
      });
      categories = tmp_cats;
    } else {
      const tmp_cats = [];
      this.listStatus.forEach(e => {
        tmp_cats.push(e.name);
      });
      categories = tmp_cats;
    }

    this.optionCompare = {
      chart: {
        type: 'bar',
        height: 400,
        width: 800,
      },
      title: {
        text: 'Ticket',
      },
      subtitle: {
        text: '',
      },
      xAxis: [
        {
          categories: categories,
          reversed: false,
          labels: {
            step: 1,
          },
        },
        {
          // mirror axis on right side
          opposite: true,
          reversed: false,
          categories: categories,
          linkedTo: 0,
          labels: {
            step: 1,
          },
        },
      ],
      yAxis: {
        title: {
          text: null,
        },
        labels: {
          formatter: function () {
            return Math.abs(this.value);
          },
        },
      },

      plotOptions: {
        series: {
          stacking: 'normal',
        },
      },

      tooltip: {
        formatter: function () {
          return (
            '<b>' +
            this.series.name +
            '</b><br/>' +
            '<small>' +
            this.point.category +
            '</small><br/>' +
            '<strong>' +
            Math.abs(this.point.y) +
            '</strong>'
          );
        },
      },

      series: [],
    };

    let key = 'ticket_total_';
    if (this.model.source) {
      key = 'ticket_' + this.model.source + '_';
      const _source = _.find(this.allSource, { id: this.model.source });
      if (_source) {
        this.optionCompare.subtitle.text = _source.text;
      }
    }
    const points = [];
    if (this.model.status) {
      this.model.status.forEach(e => {
        const _status = _.find(this.listStatus, { key: e });
        if (_status) {
          _status['key_chart'] = key + _status.key;
          points.push(_status);
        }
      });
    } else {
      this.listStatus.forEach(e => {
        e['key_chart'] = key + e.key;
        points.push(e);
      });
    }

    const series = [];
    const user_data_1 = {
      name: user1,
      data: [],
    };
    const user_data_2 = {
      name: user2,
      data: [],
    };

    if (points.length > 0) {
      points.forEach(e => {
        const key_chart = e['key_chart'];
        let val1 = 0;
        data1.forEach(d => {
          val1 += d[key_chart] ? -d[key_chart] : 0;
        });
        user_data_1['data'].push(val1);
        let val2 = 0;
        data2.forEach(d => {
          val2 += d[key_chart] ? d[key_chart] : 0;
        });
        user_data_2['data'].push(val2);
      });
    }
    series.push(user_data_1, user_data_2);
    this.optionCompare.series = series;
  }

  getStatus() {
    this.ticketService.status().subscribe(res => {
      const statusList = [{ id: '', text: '' }];
      this.listStatus = res.data;
      res.data.forEach((c: any) => {
        statusList.push({
          text: c.name,
          id: c.key,
        });
      });
      this.allStatus = statusList;
    });
  }

  loadTop(request = {}) {
    request['limit'] = 20;
    this.monitorService.top(request).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.top = res.data;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/analytic/analytic.component.ts